import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
import CameraEdit from './camera-edit'
import CameraList from './camera-list'
import CameraAdd from './camera-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Camera = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.CAMERA}
                        component={CameraList}
                    />
                    <Route
                        exact
                        path={ROUTES.CAMERA_EDIT}
                        component={CameraEdit}
                    />
                    <Route
                        exact
                        path={ROUTES.CAMERA_ADD}
                        component={CameraAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Camera)



// WEBPACK FOOTER //
// ./src/pages/camera/index.js